import { render } from "./SendMessageView.vue?vue&type=template&id=74628310"
import script from "./SendMessageView.vue?vue&type=script&lang=js"
export * from "./SendMessageView.vue?vue&type=script&lang=js"

import "./SendMessageView.vue?vue&type=style&index=0&id=74628310&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__